"use strict";

var _interopRequireDefault = require("/var/lib/jenkins/workspace/pay-center-front-master/node_modules/@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.array.find");

var _typeof2 = _interopRequireDefault(require("/var/lib/jenkins/workspace/pay-center-front-master/node_modules/@babel/runtime-corejs2/helpers/typeof"));

require("core-js/modules/es6.function.name");

var _objectSpread2 = _interopRequireDefault(require("/var/lib/jenkins/workspace/pay-center-front-master/node_modules/@babel/runtime-corejs2/helpers/objectSpread2"));

var _index = _interopRequireDefault(require("@/components/Pagination/index"));

var _waves = _interopRequireDefault(require("@/directive/waves"));

var _lang = _interopRequireDefault(require("@/lang"));

var _httpUtils = _interopRequireDefault(require("@/utils/http-utils"));

var _PermissionPage = _interopRequireDefault(require("@/components/Page/PermissionPage"));

var _PermissionSimplePage = _interopRequireDefault(require("@/components/Page/PermissionSimplePage"));

var _vuex = require("vuex");

var _CustomTableColumn = _interopRequireDefault(require("@/mixins/CustomTableColumn"));

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
// Custom Table Column Mixins (Omega Theme)
var _default = {
  name: "payChannel:view",
  mixins: [_CustomTableColumn.default],
  extends: _PermissionPage.default,
  components: {
    Pagination: _index.default,
    PermissionSimplePage: _PermissionSimplePage.default
  },
  directives: {
    waves: _waves.default
  },
  data: function data() {
    return {
      buttonLoading: false,
      tableKey: 0,
      list: null,
      // gatewayList: null,
      total: 0,
      listLoading: true,
      addDialogVisible: false,
      costRatio: 100,
      queryParameter: {
        pageNum: 1,
        pageSize: 10,
        channelName: "",
        organizationCode: "",
        gatewayType: "",
        channelStatus: ""
      },
      addInformationParameter: {
        id: "",
        channelName: "",
        organizationCode: "",
        gatewayType: "",
        implementClass: "",
        currency: "",
        weighting: "",
        channelCost: "",
        minimumAmount: "",
        maximumAmount: "",
        requestUrl: "",
        callbackUrl: "",
        tradeID: "",
        signatureKey: "",
        encryptedKey: "",
        channelStatus: "",
        settleDay: 14,
        KE1: "",
        KE2: "",
        KE3: "",
        KE4: "",
        KE5: ""
      },
      downloadLoading: false,
      updatePayChannelFlag: false,
      multipleSelection: [],
      netwayCodeEnums: [],
      rules: {
        channelName: [{
          required: true,
          message: _lang.default.t("channel.channelNameText") + " " + _lang.default.t("warningMessage.cannotBeEmpty"),
          trigger: "change"
        }],
        organizationCode: [{
          required: true,
          message: _lang.default.t("channel.organizationCodeText") + " " + _lang.default.t("warningMessage.cannotBeEmpty"),
          trigger: "change"
        }],
        gatewayType: [{
          required: true,
          message: _lang.default.t("channel.gatewayTypeText") + " " + _lang.default.t("warningMessage.cannotBeEmpty"),
          trigger: "change"
        }],
        implementClass: [{
          required: true,
          message: _lang.default.t("channel.implementClassText") + " " + _lang.default.t("warningMessage.cannotBeEmpty"),
          trigger: "change"
        }],
        // currency: [
        //   {
        //     required: true,
        //     message:
        //       i18n.t("common.currencyType") + " " +
        //       i18n.t("warningMessage.cannotBeEmpty"),
        //     trigger: "change",
        //   },
        // ],
        channelCost: [{
          required: true,
          message: _lang.default.t("channel.channelCostText") + " " + _lang.default.t("warningMessage.cannotBeEmpty"),
          trigger: "change"
        }],
        minimumAmount: [{
          required: true,
          message: _lang.default.t("channel.minimumAmountText") + " " + _lang.default.t("warningMessage.cannotBeEmpty"),
          trigger: "change"
        }],
        maximumAmount: [{
          required: true,
          message: _lang.default.t("channel.maximumAmountText") + " " + _lang.default.t("warningMessage.cannotBeEmpty"),
          trigger: "change"
        }],
        weighting: [{
          required: true,
          message: _lang.default.t("channel.weightingText") + " " + _lang.default.t("warningMessage.cannotBeEmpty"),
          trigger: "change"
        }],
        requestUrl: [{
          required: true,
          message: _lang.default.t("channel.requestUrlText") + " " + _lang.default.t("warningMessage.cannotBeEmpty"),
          trigger: "change"
        }],
        callbackUrl: [{
          required: true,
          message: _lang.default.t("channel.callbackUrlText") + " " + _lang.default.t("warningMessage.cannotBeEmpty"),
          trigger: "change"
        }],
        tradeID: [{
          required: true,
          message: _lang.default.t("channel.tradeIDText") + " " + _lang.default.t("warningMessage.cannotBeEmpty"),
          trigger: "change"
        }],
        signatureKey: [{
          required: true,
          message: _lang.default.t("channel.signatureKeyText") + " " + _lang.default.t("warningMessage.cannotBeEmpty"),
          trigger: "change"
        }],
        channelStatus: [{
          required: true,
          message: _lang.default.t("channel.channelStatusText") + " " + _lang.default.t("warningMessage.cannotBeEmpty"),
          trigger: "change"
        }]
      }
    };
  },
  computed: (0, _objectSpread2.default)({}, (0, _vuex.mapGetters)(['smsChannelStatusOptions', 'netwayCodeOption', 'currencyTypeOption'])),
  created: function created() {
    this.handleNetwayCode();
    this.getCostRatio(); // this.initList();

    this.getList();
  },
  methods: {
    getCostRatio: function getCostRatio() {
      var _this2 = this;

      _httpUtils.default.post("code", "getCostRatio", null, null).then(function (res) {
        //let index;
        _this2.costRatio = parseInt(res.data.costRatio.name);
      });
    },
    handleNetwayCode: function handleNetwayCode() {
      this.netwayCodeEnums = this.$store.getters.netwayCodeEnums;

      if (this.netwayCodeEnums == null || (0, _typeof2.default)(this.netwayCodeEnums) != 'object' || this.netwayCodeEnums.length < 1) {
        this.netwayCodeEnums = this.netwayCodeOption;
      }
    },
    getList: function getList() {
      var _this3 = this;

      //Set the loading button for table
      this.listLoading = true; //Get search parameters

      var params = this.getQueryParams();

      _httpUtils.default.post("payChannel", "list", null, params).then(function (res) {
        _this3.list = res.data.rows;
        _this3.total = res.data.total;
      });

      setTimeout(function () {
        _this3.listLoading = false;
      }, 1 * 1000);
    },
    //Get search parameter for backend service
    getQueryParams: function getQueryParams() {
      return {
        pageNum: this.queryParameter.pageNum,
        pageSize: this.queryParameter.pageSize,
        channelName: this.queryParameter.channelName,
        merchNo: this.queryParameter.organizationCode,
        netwayCode: this.queryParameter.gatewayType,
        stateCode: this.queryParameter.channelStatus
      };
    },
    //Refresh table
    handleFilter: function handleFilter() {
      //Reset the page number of table
      this.queryParameter.pageNum = 1;
      this.getList();
    },
    //Get input parameters for backend service
    getAddInformationParameter: function getAddInformationParameter() {
      return {
        id: this.addInformationParameter.id,
        channelName: this.addInformationParameter.channelName,
        merchNo: this.addInformationParameter.organizationCode,
        netwayCode: this.addInformationParameter.gatewayType,
        implFullClass: this.addInformationParameter.implementClass,
        currency: this.addInformationParameter.currency,
        weight: this.addInformationParameter.weighting,
        cost: this.addInformationParameter.channelCost,
        minAmount: this.addInformationParameter.minimumAmount,
        maxAmount: this.addInformationParameter.maximumAmount,
        requestUrl: this.addInformationParameter.requestUrl,
        callbackUrl: this.addInformationParameter.callbackUrl,
        payCode: this.addInformationParameter.tradeID,
        signKey: this.addInformationParameter.signatureKey,
        encryptKey: this.addInformationParameter.encryptedKey,
        stateCode: this.addInformationParameter.channelStatus,
        settleDay: this.addInformationParameter.settleDay,
        key1: this.addInformationParameter.KE1,
        key2: this.addInformationParameter.KE2,
        key3: this.addInformationParameter.KE3,
        key4: this.addInformationParameter.KE4,
        key5: this.addInformationParameter.KE5
      };
    },
    handleAdd: function handleAdd() {
      var _this4 = this;

      var _this = this;

      this.$refs["addInformation"].validate(function (valid) {
        if (valid) {
          _this4.buttonLoading = true;
          _this4.listLoading = false;

          var params = _this.getAddInformationParameter();

          if (_this.updatePayChannelFlag) {
            _httpUtils.default.post("payChannel", "update", null, params).then(function (res) {
              if (res.code == 200) {
                _this4.$message({
                  message: _lang.default.t("warningMessage.updatePayChannelSuccessMessage"),
                  type: "success"
                });
              }

              if (res.code == 500) {
                _this4.$message({
                  message: res.message,
                  type: "error"
                });
              }

              _this4.handleResetAdd();

              _this4.handleFilter();
            }).catch(function (error) {
              _this4.$message({
                message: error.message,
                type: "error"
              });
            });
          } else {
            _httpUtils.default.post("payChannel", "add", null, params).then(function (res) {
              if (res.code == 200) {
                _this4.$message({
                  message: _lang.default.t("warningMessage.addPayChannelSuccessMessage"),
                  type: "success"
                });
              }

              if (res.code == 500) {
                _this4.$message({
                  message: res.message,
                  type: "error"
                });
              }

              _this4.handleResetAdd();

              _this4.handleFilter();
            }).catch(function (error) {
              _this4.$message({
                message: error.message,
                type: "error"
              });
            });
          }

          setTimeout(function () {
            _this4.listLoading = false;
          }, 1 * 1000);
        } else {
          return false;
        }
      });
    },
    //Fill in parameter for updating pay channel setting
    handleAddExistChannel: function handleAddExistChannel() {
      console.log(this.multipleSelection);

      if (this.multipleSelection.length != 1) {
        this.$message({
          message: _lang.default.t("warningMessage.selectPayChannelToCopy"),
          type: "error"
        });
        return;
      }

      var row = this.multipleSelection[0];
      this.addInformationParameter.channelName = row.channelName;
      this.addInformationParameter.organizationCode = row.merchNo;
      this.addInformationParameter.gatewayType = row.netwayCode;
      this.addInformationParameter.implementClass = row.implFullClass;
      this.addInformationParameter.currency = row.currency;
      this.addInformationParameter.weighting = row.weight;
      this.addInformationParameter.channelCost = row.cost;
      this.addInformationParameter.minimumAmount = row.minAmount;
      this.addInformationParameter.maximumAmount = row.maxAmount;
      this.addInformationParameter.requestUrl = row.requestUrl;
      this.addInformationParameter.callbackUrl = row.callbackUrl;
      this.addInformationParameter.tradeID = row.payCode;
      this.addInformationParameter.signatureKey = row.signKey;
      this.addInformationParameter.encryptedKey = row.encryptKey;
      this.addInformationParameter.channelStatus = row.stateCode;
      this.addInformationParameter.settleDay = row.settleDay;
      this.addInformationParameter.KE1 = row.key1;
      this.addInformationParameter.KE2 = row.key2;
      this.addInformationParameter.KE3 = row.key3;
      this.addInformationParameter.KE4 = row.key4;
      this.addInformationParameter.KE5 = row.key5;
      this.addDialogVisible = true;
    },
    //Fill in parameter for updating pay channel setting
    handleUpdateCheck: function handleUpdateCheck(row) {
      this.addInformationParameter.id = row.id;
      this.addInformationParameter.channelName = row.channelName;
      this.addInformationParameter.organizationCode = row.merchNo;
      this.addInformationParameter.gatewayType = row.netwayCode;
      this.addInformationParameter.implementClass = row.implFullClass;
      this.addInformationParameter.currency = row.currency;
      this.addInformationParameter.weighting = row.weight;
      this.addInformationParameter.channelCost = row.cost;
      this.addInformationParameter.minimumAmount = row.minAmount;
      this.addInformationParameter.maximumAmount = row.maxAmount;
      this.addInformationParameter.requestUrl = row.requestUrl;
      this.addInformationParameter.callbackUrl = row.callbackUrl;
      this.addInformationParameter.tradeID = row.payCode;
      this.addInformationParameter.signatureKey = row.signKey;
      this.addInformationParameter.encryptedKey = row.encryptKey;
      this.addInformationParameter.channelStatus = row.stateCode;
      this.addInformationParameter.settleDay = row.settleDay;
      this.addInformationParameter.KE1 = row.key1;
      this.addInformationParameter.KE2 = row.key2;
      this.addInformationParameter.KE3 = row.key3;
      this.addInformationParameter.KE4 = row.key4;
      this.addInformationParameter.KE5 = row.key5;
      this.addDialogVisible = true;
      this.updatePayChannelFlag = true;
    },
    deletePayChannel: function deletePayChannel(payChannelIds) {
      var _this5 = this;

      _httpUtils.default.post("payChannel", "batchDelete", null, payChannelIds).then(function (res) {
        _this5.$message({
          message: _lang.default.t("warningMessage.deletePayChannelSuccessMessage"),
          type: "success"
        });

        _this5.handleFilter();
      }).catch(function (err) {
        _this5.$message({
          message: err.message,
          type: "error"
        });
      });
    },
    handleDelete: function handleDelete(id) {
      var _this6 = this;

      this.$confirm(_lang.default.t("warningMessage.deletePayChannelConfirmMessage"), _lang.default.t("warningMessage.deletePayChannelMessage"), {
        confirmButtonText: _lang.default.t("common.confirm"),
        cancelButtonText: _lang.default.t("common.cancel"),
        type: "warning"
      }).then(function () {
        var payChannelIds = [];
        payChannelIds.push(id);

        _this6.$nextTick(function (_) {
          _this6.deletePayChannel(payChannelIds);
        });
      }).catch(function (_) {});
    },
    handleBatchDelete: function handleBatchDelete() {
      var _this7 = this;

      if (!this.multipleSelection.length) {
        this.$message({
          message: _lang.default.t("warningMessage.selectPayChannelToDeleteMessage"),
          type: "error"
        });
      } else {
        this.$confirm(_lang.default.t("warningMessage.deletePayChannelConfirmMessage"), _lang.default.t("warningMessage.deletePayChannelMessage"), {
          confirmButtonText: _lang.default.t("common.confirm"),
          cancelButtonText: _lang.default.t("common.cancel"),
          type: "warning"
        }).then(function () {
          var payChannelIds = [];

          for (var item in _this7.multipleSelection) {
            payChannelIds.push(_this7.multipleSelection[item].id);
          }

          _this7.$nextTick(function (_) {
            _this7.deletePayChannel(payChannelIds);
          });
        }).catch(function (_) {});
      }
    },
    handleReset: function handleReset() {
      this.queryParameter.channelName = "";
      this.queryParameter.organizationCode = "";
      this.queryParameter.gatewayType = "";
      this.queryParameter.channelStatus = "";
      this.addInformationParameter.channelName = "";
      this.addInformationParameter.organizationCode = "";
      this.addInformationParameter.gatewayType = "";
      this.addInformationParameter.implementClass = "";
      this.addInformationParameter.currency = "";
      this.addInformationParameter.weighting = "";
      this.addInformationParameter.channelCost = "";
      this.addInformationParameter.minimumAmount = "";
      this.addInformationParameter.maximumAmount = "";
      this.addInformationParameter.requestUrl = "";
      this.addInformationParameter.callbackUrl = "";
      this.addInformationParameter.tradeID = "";
      this.addInformationParameter.signatureKey = "";
      this.addInformationParameter.encryptedKey = "";
      this.addInformationParameter.channelStatus = "";
      this.addInformationParameter.settleDay = 14;
      this.addInformationParameter.KE1 = "";
      this.addInformationParameter.KE2 = "";
      this.addInformationParameter.KE3 = "";
      this.addInformationParameter.KE4 = "";
      this.addInformationParameter.KE5 = "";
      this.buttonLoading = false;
    },
    handleResetAdd: function handleResetAdd() {
      var _this8 = this;

      this.addDialogVisible = false;
      this.updatePayChannelFlag = false;
      this.handleReset();
      this.$nextTick(function (_) {
        _this8.$refs["addInformation"].clearValidate();
      });
    },
    //Checking for update cost function
    handleUpdateCostCheck: function handleUpdateCostCheck() {
      var _this = this;

      if (!_this.multipleSelection.length) {
        this.$message({
          message: _lang.default.t("warningMessage.configureChannelCostMessage"),
          type: "error"
        });
      } else {
        if (_this.multipleSelection.length == 1) {
          this.handleCost(this.multipleSelection[0].id);
        } else {
          this.$message({
            message: _lang.default.t("warningMessage.pleaseSelectOneChannelMessage"),
            type: "error"
          });
        }
      }
    },
    handleCost: function handleCost(id) {
      var _this9 = this;

      // Set cache items to localStorage
      this.$store.dispatch('cacheManager/setPageCacheItemsMap', {
        page: 'payChannelCost:view',
        cacheItems: [{
          key: 'payChannelCost',
          value: id
        }]
      }).then(function () {
        _this9.$router.push({
          name: "payChannelCost:view"
        });
      });
    },
    convertStatusOptionName: function convertStatusOptionName(name) {
      if (!this.smsChannelStatusOptions || !this.smsChannelStatusOptions.length > 0) {
        return "";
      }

      var state = this.smsChannelStatusOptions.find(function (status) {
        return parseInt(status.key) == name;
      });

      if (state) {
        return state.display_name;
      } else {
        return "";
      }
    },
    convertGatewayTypeOptionName: function convertGatewayTypeOptionName(name) {
      if (!this.netwayCodeEnums || !this.netwayCodeEnums.length > 0) {
        return "";
      }

      var gateway = this.netwayCodeEnums.find(function (gateway) {
        return gateway.key == name;
      });

      if (gateway) {
        return gateway.display_name;
      } else {
        return "";
      }
    },
    convertCurrencyTypeOptionName: function convertCurrencyTypeOptionName(name) {
      var found = '';
      this.currencyTypeOption.forEach(function (status) {
        if (status.key == name) {
          found = status.display_name;
          return;
        }
      });
      return found;
    },
    //Handle add check boxes for table
    handleSelectionChange: function handleSelectionChange(val) {
      this.multipleSelection = val;
    }
  }
};
exports.default = _default;